export default "__VITE_ASSET__DYA_XOoB__"